<div class="function-container">
  <opath-core-nav-header
    [title]="translation.functions.title"
    [buttons]="functionButtons"
    [height]="100"
    (onFilterOptionChanged)="filterOptionChanged($event)"
    (onSearchTermChanged)="searchTermChanged($event)"
  >
  </opath-core-nav-header>

  <div class="functions-body">
    <abc-tree
      #entityTree
      [useNativeScrolling]="true"
      [searchEnabled]="false"
      [searchValue]="searchValue"
      [searchMode]="currentFilterOption?.searchMode"
      selectionMode="none"
      hasItemsExpr="children"
      [dataSource]="rootTreeNodes"
      (onItemClick)="handleFunctionSelected($event)"
      [focusStateEnabled]="false"
      [selectByClick]="false"
      class="tree-caption"
    >
      <div *dxTemplate="let data of 'item'">
        <abc-button
          class="function-button tree-item"
          [text]="data.caption"
          [toolTipContent]="
            (data?.data?.description && data?.data?.description?.length) > 0 ? data.data.description : data.caption
          "
          [icon]="'formula'"
        ></abc-button>
      </div>
    </abc-tree>
  </div>
</div>
